import React from 'react';
import { Link } from '@atlassian/react-resource-router';
import type { Author } from '../../types.tsx';
import { buildAccountUrl } from '../utils.tsx';
import { useSummaryFeatures } from '../../../controllers/features-context/index.tsx';

type UsernameDisplayProps = {
	user: Author;
	onClick?: () => void;
};

export const UsernameDisplay = ({ user, onClick }: UsernameDisplayProps) => {
	const { linksTarget } = useSummaryFeatures();

	if (user.displayName === 'Unknown') {
		return user.displayName;
	}

	return (
		<Link
			href={buildAccountUrl(user.accountId)}
			target={linksTarget}
			onClick={() => {
				onClick?.();
			}}
		>
			{user.displayName}
		</Link>
	);
};
